import type {
  ShareResourceCandidate,
  ShareResourceMember,
} from 'components/share-resource/types'
import { initialsFor } from 'features/trend-detection/components/agent-sharing-calls'
import type {
  AgentCollaborator,
  AgentCollaboratorsResponse,
} from 'features/trend-detection/types'

/** Editors (owners) first, then viewers — display order for `ShareResource`.
 * Keyed by email, since agents have no per-person role concept. */
export function toShareMembers(
  collaborators: AgentCollaboratorsResponse | null,
): ShareResourceMember[] {
  const toMember = (
    collaborator: AgentCollaborator,
    staticRole?: string,
  ): ShareResourceMember => ({
    id: collaborator.email,
    name: collaborator.full_name || collaborator.email,
    secondaryLabel: collaborator.full_name ? collaborator.email : undefined,
    initials: initialsFor(collaborator),
    staticRole,
  })

  return [
    ...(collaborators?.editors ?? []).map((editor) =>
      toMember(editor, 'Owner'),
    ),
    ...(collaborators?.viewers ?? []).map((viewer) => toMember(viewer)),
  ]
}

/** Emails not already a collaborator, as picker candidates. */
export function toShareCandidates(
  allEmails: string[],
  collaborators: AgentCollaboratorsResponse | null,
): ShareResourceCandidate[] {
  const taken = new Set(
    [...(collaborators?.editors ?? []), ...(collaborators?.viewers ?? [])].map(
      (c) => c.email,
    ),
  )
  return allEmails
    .filter((email) => !taken.has(email))
    .map((email) => ({ id: email, label: email }))
}
